import React, { useEffect, useState } from "react";
import styles from "./audioChat.module.scss";
import { Tooltip } from "antd";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatAudioInner from "../chatAudioInner";
import moment from "moment";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import { useSelector } from "react-redux";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { chats, initialStateModel } from "../../../../models/model";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import _ from "lodash";
import ForwardHeader from "../forwardHeader";
import { urlify, urlifyATmention } from "../../../../base/utils";
type audioMessageProps = {
  data: any;
  multiData?: any;
  savedData?: any;
  key?: any;
  timeValue?: any;
};

export default function ChatAudioMessage({ data, multiData, savedData, key, timeValue }: audioMessageProps) {
  let { direction, timestamp, fromcaller_details, id, message } =
    Array.isArray(data) && data?.length > 0 ? data[0] : "";
  let isReply = Array.isArray(data) && data?.length > 0 && data[0].message?.isReply ? true : false;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  let htimestamp = moment(timestamp).format("hh:mm A");
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const [longText, setlongtext] = useState(0);
  let messageBody =message?.body;
  let mstext = message?.body?.text;
  if(mstext && mstext !== ""){
    if (mstext?.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
  }
  if(messageBody?.mentionID !== '' && messageBody?.mentionID !== undefined ){
    let test = urlifyATmention(messageBody ,mstext)
    mstext = test;
   }
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  const handleCheckBoxClick = () => {
    if (chatReducer?.isDelete || chatReducer?.isForward) {
      //ChatService.selectedMessageDispatch(data);
    }
  };
  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
  }, [savedData]);
  const handleOnChange = (e: any) => {
    let deletedArray: any = chatReducer.selectMessageData;
    let index = [];
    if (e.target.checked) {
      let arr: any = [...deletedArray, ...multiData];
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: arr
        }
      });
    } else {
      _.forEach(multiData, function (element: any) {
        index = deletedArray.indexOf(element);
        deletedArray.splice(index, 1);
      });

      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
    }
  };

  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
  };
  let isBookmark:any = data[0]?.message?.isSave;
  let widthMulti = (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data[0]?.message?.isEdit ?"saveEdited": 
  (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data[0]?.message?.isEdit ? "onlyEdited" : "widthDefault";
 
  // console.log(message,"Direction --->",direction);
  return (
    <React.Fragment>
      {direction === "IN" ? (
        <div
          className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} lftMessage ${styles.chatMsg} ${
            styles.leftMessage
          }  ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption? "checking":""}`}
          id={id}
        >
          {!isReply && timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
            {!isReply && <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className="userinfoIcon leftSide" />}
            <div className={styles.convMemName}>
              <span>{fromcaller_details===undefined?'Unknown User':fromcaller_details?.caller_id}</span>
            </div>
          </div>}
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              <div className={`msgContentLft ${styles.chatContent}`}>
              {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                {!isReply && (
                  <Tooltip
                    mouseEnterDelay={0.5}
                    title={htimestamp}
                    className="cusTooltip"
                    overlayClassName="customTooltip"
                  >
                    <div className={styles.chatTime}>{htimestamp}</div>
                  </Tooltip>
                )}
                {data?.map((msgList: any, index: any) => {
                  if (msgList?.direction === "IN") {
                    return (
                      <React.Fragment key={index}>
                        <div className={styles.chatAudioList}>
                          <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0}>
                            <ChatAudioInner data={msgList} userDetails={fromcaller_details} hoverdata={data[0]} />
                          </span>
                        </div>
                      </React.Fragment>
                    );
                  } else {
                    return null;
                  }
                })}
                
                {!isReply && (
                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption
                      className="hoverList hoverListleft"
                      data={data[0]}
                      multiFile={multiData}
                      highlightHover={handlehighlightHover}
                    />
                  </div>
                )}
               
                      <div className="textContent">
                     {message?.body?.text && message?.body?.text !== "" && <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>}
                      <span className={widthMulti}></span>
                    </div>
                    
                {!isReply && (
                  <ChatLeftInfo
                    userDetails={fromcaller_details}
                    timeStamp={timestamp}
                    message={Array.isArray(data) && data.length > 0 ? data[0] : []}
                  ></ChatLeftInfo>
                )}
              </div>
            </div>
            {!isReply && (
              <ChatLike className="likeLeft" placement="top" tooltipTitle={data?.likeduserdetails} message={data[0]} />
            )}
          </div>
          {(chatReducer?.multiOption && !chatReducer?.isDelete) && (
            <URCheckBoxCall
              checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
              className="chatSelectRight"
              onChange={handleOnChange}
            />
          )}
        </div>
      ) : (
        <div
          className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} rtMessage ${styles.chatMsg} ${
            styles.rightMessage
          } 
          ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption? "checking":""}`}
          onClick={handleCheckBoxClick}
          id={id}
        >
          {!isReply && timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
            <div className={styles.convMemName}>
              <span>You</span>
            </div>
            <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className="userinfoIcon rightSide" />
            {/* {!isReply && timeCount > 15 && (
              <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon rightSide" />
            )} */}
          </div>}
          <div className={styles.chatRightMessages}>
            <div className={styles.chatRight}>
              <div className={`msgContentRT ${styles.chatContent}`}>
              {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                <div className={styles.chatAudioList}>
                  {data?.map((msgList: any, index: any) => {
                    // console.log("msgList directrion --->",msgList);
                    if (msgList?.direction === "OUT") {
                      return (
                        <React.Fragment key={index}>
                          <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0}>
                            <ChatAudioInner data={msgList} userDetails={fromcaller_details} hoverdata={data[0]} />
                          </span>
                          
                        
                        </React.Fragment>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
             
               
                      <div className="textContent">
                      {message?.body?.text && message?.body?.text !== "" &&  <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>}
                      <span className={widthMulti}></span>
                    </div>
                    
                {!isReply && (
                  <ChatRightInfo
                    userDetails={fromcaller_details}
                    timeStamp={timestamp}
                    message={Array.isArray(data) && data.length > 0 ? data[0] : []}
                  ></ChatRightInfo>
                )}
                {!isReply && (
                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption
                      className="hoverList hoverListright"
                      data={data[0]}
                      multiFile={data}
                      highlightHover={handlehighlightHover}
                    />
                  </div>
                )}
              </div>
              {!isReply && (
                <Tooltip
                  mouseEnterDelay={0.5}
                  placement="topRight"
                  title={htimestamp}
                  className="cusTooltip"
                  overlayClassName="customTooltip"
                >
                  <div className={styles.chatTime}>{htimestamp}</div>
                </Tooltip>
              )}
            </div>
            <ChatLike
                  className="likeRight"
                  placement="topRight"
                  tooltipTitle={data?.likeduserdetails}
                  message={data[0]}
                />
          </div>

          {(!chatReducer?.isDelete && chatReducer?.multiOption) && (
            <URCheckBoxCall
              checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
              className="chatSelectRight"
              onChange={handleOnChange}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
}
